module.exports = __webpack_public_path__ + "static/trees-3.10-f380bbcb3e8788a1d27b278407284be6.png";